import FindALawyerResultsAsync from './FindALawyerResultsAsync';

export default FindALawyerResultsAsync;
